// Druhé menu (.nav-menu) se při scrollu dolů schová, při scrollu nahoru zase ukáže – stejně jako na www.agelplus.cz
$(function () {
	let lastScrollTop = 0;

	$(window).on('scroll', function () {
		const st = $(this).scrollTop();

		if (st > 60 && st > lastScrollTop) {
			$('.nav-menu').addClass('hidden');
		} else {
			$('.nav-menu').removeClass('hidden');
		}

		lastScrollTop = st;
	});
});

// Mobilní menu – hamburger otevírá/zavírá rozbalovací nav-menu (druhé menu)
$(function () {
	const $nav = $('.nav');
	const $burger = $nav.find('.nav-burger');

	if (!$burger.length) {
		return;
	}

	function setOpen(open) {
		$nav.toggleClass('is-menu-open', open);
		// morf hamburgeru na X (stejně jako na agelplus.cz – třída isOpened)
		$burger.toggleClass('isOpened', open);
		$burger.attr('aria-expanded', open ? 'true' : 'false');
		if (open) {
			// při otevření menu zavřeme vyhledávání
			$nav.removeClass('is-search-open');
			$('.body-content').removeClass('search-open');
		}
	}

	$burger.on('click', function () {
		setOpen(!$nav.hasClass('is-menu-open'));
	});

	// klik na tmavé pozadí menu zavře
	$nav.find('.mobile-menu-backdrop').on('click', function () {
		setOpen(false);
	});

	// zavřít při kliknutí mimo menu
	$(document).on('click', function (e) {
		if (!$nav.hasClass('is-menu-open')) {
			return;
		}
		if (!$(e.target).closest('.nav-menu, .nav-burger').length) {
			setOpen(false);
		}
	});
});

// Vyhledávání – lupa rozbalí/sbalí vyhledávací řádek pod hlavičkou (desktop i mobil)
$(function () {
	const $nav = $('.nav');
	const $toggle = $nav.find('.nav-search-toggle');
	const $row = $nav.find('.nav-search-row');

	if (!$toggle.length || !$row.length) {
		return;
	}

	// placeholder dle návrhu (jen pro agelplus, neovlivní sdílený SearchForm)
	$row.find('input[type="text"], input:not([type])').attr('placeholder', 'Hledat balíček nebo službu…');

	function setSearchOpen(open) {
		$nav.toggleClass('is-search-open', open);
		// odsazení obsahu, ať otevřené pole nepřekrývá záložky
		$('.body-content').toggleClass('search-open', open);
		$toggle.attr('aria-expanded', open ? 'true' : 'false');
		if (open) {
			// při otevření hledání zavřeme mobilní menu
			$nav.removeClass('is-menu-open');
			$row.find('input[type="text"], input:not([type])').first().trigger('focus');
		}
	}

	$toggle.on('click', function () {
		setSearchOpen(!$nav.hasClass('is-search-open'));
	});

	$row.find('.nav-search-close').on('click', function () {
		setSearchOpen(false);
	});

	// Esc zavře vyhledávání
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $nav.hasClass('is-search-open')) {
			setSearchOpen(false);
		}
	});
});

// Katalog – po načtení posuneme záložky tak, aby byla aktivní kategorie vidět
$(function () {
	const $inner = $('.cat-nav__inner');
	const $active = $inner.find('.cat-tab.is-active');

	if (!$inner.length || !$active.length) {
		return;
	}

	const inner = $inner.get(0);
	const active = $active.get(0);
	const target = active.offsetLeft - (inner.clientWidth - active.offsetWidth) / 2;

	inner.scrollLeft = Math.max(0, target);
});

// Katalog – posun kategorií bez viditelného scrollbaru: kolečkem do strany + chytni a táhni
$(function () {
	const $inner = $('.cat-nav__inner');

	if (!$inner.length) {
		return;
	}

	const inner = $inner.get(0);

	// kolečko myši posouvá vodorovně
	$inner.on('wheel', function (e) {
		const delta = e.originalEvent.deltaY;
		if (!delta) {
			return;
		}
		// posun jen pokud je vůbec kam (jinak necháme normální scroll stránky)
		if (inner.scrollWidth <= inner.clientWidth) {
			return;
		}
		inner.scrollLeft += delta;
		e.preventDefault();
	});

	// chytni a táhni myší
	let isDown = false;
	let startX = 0;
	let startScroll = 0;
	let moved = false;

	$inner.on('mousedown', function (e) {
		isDown = true;
		moved = false;
		startX = e.pageX;
		startScroll = inner.scrollLeft;
		$inner.addClass('is-dragging');
	});

	$(document).on('mousemove', function (e) {
		if (!isDown) {
			return;
		}
		const walk = e.pageX - startX;
		if (Math.abs(walk) > 3) {
			moved = true;
		}
		inner.scrollLeft = startScroll - walk;
		e.preventDefault();
	});

	$(document).on('mouseup', function () {
		isDown = false;
		$inner.removeClass('is-dragging');
	});

	// po tažení nezpůsobit přechod na kategorii (jinak by drag bral i jako klik)
	$inner.on('click', 'a', function (e) {
		if (moved) {
			e.preventDefault();
		}
	});
});
